/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';

import { addNewProduct, editExistingProduct } from '../state/products';
import { FormInputField } from '../components/form/FormInputField';
import { generateFormErrors } from '../utils/generateFormErrors';

const NewProductForm = styled(Form)`
  display: flex;
  flex-direction: column;
`;

function ProductForm({
  t, history, addNewProduct, editExistingProduct, product, bindSubmitForm,
}) {
  return (
    <Formik
      initialValues={{
        name: product.name || '',
        description: product.description || '',
        status: product.status || false,
      }}
      onSubmit={async (values, { resetForm, setErrors }) => {
        try {
          if (isEmpty(product)) {
            await addNewProduct(values);
          } else {
            await editExistingProduct(product.id, values);
          }
          resetForm();
          history.push('/products');
        } catch (error) {
          const errorFields = generateFormErrors(error);
          setErrors(errorFields);
        }
      }}
      render={(props) => {
        bindSubmitForm(props.submitForm);
        return (
          <NewProductForm>
            <FormInputField
              inputId="ProductForm.Input.Name"
              label={t('Pages.Products.FormFields.Name')}
              labelId="ProductForm.Label.Name"
              name="name"
              placeholder={t('Pages.Products.Placeholders.Name')}
              type="text"
              error={props.errors.name}
              isRequired
            />

            <FormInputField
              inputId="ProductForm.Input.Description"
              label={t('Pages.Products.FormFields.Description')}
              labelId="ProductForm.Label.Description"
              name="description"
              component="textarea"
              rows="5"
              type={null}
              placeholder={t('Pages.Products.Placeholders.Description')}
              error={props.errors.description}
            />

            <FormInputField
              label={t('Shared.FormFields.Status')}
              inputId="ProductForm.Input.Status"
              labelId="ProductForm.Label.Status"
              name="status"
              placeholder={t('Shared.Placeholders.Status')} // do we need placeholder for checkbox?
              type="checkbox"
              checked={props.values.status}
              error={props.errors.status}
              isRequired={!!isEmpty(product)}
            />
          </NewProductForm>
        );
      }}
    />
  );
}

ProductForm.propTypes = {
  t: PropTypes.func.isRequired, // supplied from withTranslation
  addNewProduct: PropTypes.func.isRequired, // supplied from Redux
  bindSubmitForm: PropTypes.func.isRequired,
  editExistingProduct: PropTypes.func.isRequired, // supplied from Redux
  history: PropTypes.object.isRequired, // supplied from React Router
  product: PropTypes.object,
};

ProductForm.defaultProps = {
  product: {},
};

const mapDispatchToProps = {
  addNewProduct,
  editExistingProduct,
};

const TranslatedComponent = withTranslation()(ProductForm);
const RouterComponent = withRouter(TranslatedComponent);
export default connect(
  null,
  mapDispatchToProps,
)(RouterComponent);
